import {
  MemoizedSelector,
  createFeatureSelector,
  createSelector,
} from '@ngrx/store';
import { ErrorStore, SharedAnalysisResults } from '@sleipai/sleip-models';
import {
  State,
  sharedAnalysisResultsFeatureKey,
  selectAllSharedAnalysisResultsAdapter,
} from '../reducers/shared-analysis-results.reducer';
import * as fromRouterSelector from '../../router-store/router.selectors';

export const selectSharedAnalysisResultsStoreState =
  createFeatureSelector<State>(sharedAnalysisResultsFeatureKey);

export const isLoaded = (state: State): boolean => state.loaded;
export const isLoading = (state: State): boolean => state.loading;
export const SharedAnalysisResultsError = (state: State): ErrorStore | null =>
  state.error;

export const selectIsLoading: MemoizedSelector<object, boolean> =
  createSelector(selectSharedAnalysisResultsStoreState, isLoading);

export const selectIsLoaded: MemoizedSelector<object, boolean> = createSelector(
  selectSharedAnalysisResultsStoreState,
  isLoaded
);

export const selectSharedAnalysisResultsError: MemoizedSelector<
  object,
  ErrorStore | null
> = createSelector(
  selectSharedAnalysisResultsStoreState,
  SharedAnalysisResultsError
);

export const selectAllSharedAnalysisResults = createSelector(
  selectSharedAnalysisResultsStoreState,
  selectAllSharedAnalysisResultsAdapter
);

export const selectSingleSharedAnalysisResultsByIdAndKey = createSelector(
  selectAllSharedAnalysisResults,
  fromRouterSelector.selectRouteNestedParam('publicRecordingId'),
  fromRouterSelector.selectRouteNestedQueryParam('publicKey'),
  (
    sharedAnalysisResults: SharedAnalysisResults[],
    publicRecordingId: string,
    publicKey: string
  ) => {
    if (sharedAnalysisResults) {
      return (
        sharedAnalysisResults.filter(
          (SharedAnalysisResult) =>
            SharedAnalysisResult.publicSharedRecordingId ===
              publicRecordingId && SharedAnalysisResult.publicKey === publicKey
        ) ?? null
      );
    } else {
      return null;
    }
  }
);
